// Path: ./src/utils/banner/bannerTranslate.ts
import {
  BANNER_CONTENT_FIELDS,
  BannerContentField,
  BannerLocaleSuffix,
  bannerContentField,
} from "./bannerFields";

export const BANNER_TRANSLATE_SOURCE_LANG = "en";

export type BannerTranslatableSuffix = Exclude<BannerLocaleSuffix, "">;

export const BANNER_TRANSLATE_TARGET_LANG: Record<
  BannerTranslatableSuffix,
  string
> = {
  Chinese: "zh",
  French: "fr",
};

const readContent = (
  banner: Record<string, unknown> | undefined,
  key: string,
): string => String(banner?.[key] ?? "").trim();

export const bannerFieldsNeedingTranslation = (
  banner: Record<string, unknown> | undefined,
  suffix: BannerTranslatableSuffix,
): BannerContentField[] =>
  BANNER_CONTENT_FIELDS.filter(
    (base) =>
      Boolean(readContent(banner, base)) &&
      !readContent(banner, bannerContentField(base, suffix)),
  );

export const hasBannerEnglishContent = (
  banner: Record<string, unknown> | undefined,
): boolean =>
  BANNER_CONTENT_FIELDS.some((base) => Boolean(readContent(banner, base)));
